import React, { useState, useEffect } from "react";
import { Input } from "src/@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "src/@/components/ui/select";
import { Card, CardHeader, CardContent } from "src/@/components/ui/card";
import { RadioGroup, RadioGroupItem } from "src/@/components/ui/radio-group";
import v2_actionConfigCrm from "src/actions/v2/crm/v2_actionConfigCrm";
import useAuth from "src/hooks/useAuth";
import { SelectZui } from "src/components/zui";
import { OptionsSelect } from "src/@/components/shared";
import { RowInput } from "src/components/forms/RowInput";
import transformQualifyLeadNames from "src/utils/crm.utils";
import { AlertInfo } from "src/@/components/shared/AlertInfo";

const CardChangeValue = ({ block, changeBlock }) => {
  const { cliente } = useAuth();
  const [selectedAction, setSelectedAction] = useState(block?.data?.funnelAction);
  const [configCrm, setConfigCrm] = useState(null);
  const [option, setOption] = useState(1);
  const [selectedReason, setSelectedReason] = useState(null);

  const labels = {
    1: "Sem interesse",
    2: "Frio",
    3: "Morno",
    4: "Esquentando",
    5: "Quente",
  };

  const radioItems = [
    { value: "editar_valor", id: "valor", label: "Alterar Valor" },
    { value: "editar_origem_lead", id: "origem", label: "Alterar Origem" },
    { value: "editar_qualificacao", id: "qualificacao", label: "Alterar Qualificação" },
    { value: "finalizar_negocio", id: "finalizar", label: "Finalizar Lead" },
    { value: "retomar_lead", id: "retomar", label: "Retomar Lead" },
    { value: "editar_conversao_ganho", id: "marcarVenda", label: "Marcar Venda" },
    { value: "editar_conversao_perda", id: "marcarPerda", label: "Marcar Perda" },
    { value: "editar_campanha", id: "editarCampanha", label: "Editar Campanha" }
  ];

  let newReasons = configCrm?.motivos?.map((item) => {
    return { value: item._id, label: item.name }
  });

  async function buscarConfigCrm(querys) {
    try {
      const result = await v2_actionConfigCrm(cliente._id, querys);
      if (result.data.data) {
        setConfigCrm(result.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="w-full">
      <div className="space-y-6">
        {/* Radio Group to select action */}
        <div>
          <label className="block text-sm font-bold mb-4">O que deseja fazer?</label>
          <RadioGroup
            className="flex flex-col gap-4"
            value={block?.data?.funnelAction}
            onValueChange={e => {
              let event = { name: "funnelAction", value: e }
              changeBlock(event)
              setSelectedAction(e)
              if (["editar_origem_lead", "finalizar_negocio", "editar_qualificacao", "editar_conversao_perda", "editar_campanha"].includes(e)) {
                let querys = `?cliente_id=${cliente._id}`;
                buscarConfigCrm(querys);
              }
            }}
          >
            {radioItems.map(item => (
              <div key={item.value} className="flex items-center gap-2">
                <RadioGroupItem value={item.value} id={item.value} />
                <label htmlFor={item.id} className="text-sm">{item.label}</label>
              </div>
            ))}
          </RadioGroup>
        </div>

        {/* Conditional Render based on selected action */}
        {block?.data?.funnelAction === "editar_valor" && (
          <div className="flex flex-col gap-1 w-1/4">
            <label htmlFor="valor" className="text-sm font-medium">
              Valor do négocio
            </label>
            <Input
              type="text"
              id="valor"
              name="valor"
              value={block?.data?.funnelValueLead}
              onChange={e => {
                let event = { name: "funnelValueLead", value: e.target.value }
                changeBlock(event)
              }}
              placeholder="Valor"
            />
          </div>
        )}

        {block?.data?.funnelAction === "editar_origem_lead" && (
          <div className="flex flex-col gap-1">
            <label htmlFor="origem" className="text-sm font-medium">
              Origem
            </label>
            <Select
              value={block?.data?.origin}
              onValueChange={e => {
                let event = { name: "origin", value: e }
                changeBlock(event)
              }}
            >
              <SelectTrigger>
                <SelectValue placeholder="Selecione a origem" />
              </SelectTrigger>
              <SelectContent>
                {configCrm?.origens.map((pipe) => (
                  <SelectItem key={pipe._id} value={pipe._id}>
                    {pipe.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        )}

        {block?.data?.funnelAction === "editar_qualificacao" && (
          <div className="space-y-4">
            <div className="flex flex-row items-center gap-2">
              <div className="w-1/6">
                <label className="block text-sm font-medium">Qualificação</label>
                <Input
                  type="number"
                  min="1"
                  max="5"
                  step="1"
                  value={block?.data?.qualifyLead}
                  onChange={(e) => {
                    let event = { name: "qualifyLead", value: Number(e.target.value) }
                    changeBlock(event)
                  }}
                  className="w-full"
                />
              </div>
              <span>
                {transformQualifyLeadNames(configCrm?.qualificacoes, block?.data?.qualifyLead)}
              </span>
            </div>
            <div className="text-sm text-gray-500">
              <span>
                {labels[block?.qualifyLead] || "Selecione uma pontuação válida."}
              </span>
            </div>
          </div>
        )}

        {block?.data?.funnelAction === "finalizar_negocio" && (
          <div className="text-sm font-medium text-gray-700">
            <div className='w-2/3'>
              <OptionsSelect
                title="Marcar como"
                options={[
                  { value: 1, label: 'Venda', color: 'bg-green-500' },
                  { value: 2, label: 'Perda', color: 'bg-red-500' },
                ]}
                value={block?.data.conversionTypeLead}
                changeValue={(e) => {
                  setOption(e);
                  let event = { name: "conversionTypeLead", value: Number(e) }
                  changeBlock(event)
                }}
              />
            </div>
            {option === 2 && (
              <div className="flex flex-col gap-2 mt-4">
                <RowInput
                  label={'motivo da perda'}
                  input={
                    <SelectZui
                      value={block?.data.lostReasonLead}
                      list={newReasons}
                      fullWidth
                      onChange={e => {
                        setSelectedReason(e);
                        let event = { name: "lostReasonLead", value: e }
                        changeBlock(event)
                      }}
                      itemSelect={(item) => (
                        <SelectItem key={item.value} value={item.value}>
                          {item.label}
                        </SelectItem>
                      )}
                    />
                  }
                />
              </div>
            )}
          </div>
        )}

        {block?.data?.funnelAction === "retomar_lead" && (
          <div className="mt-8">
            <AlertInfo
              title="Atenção"
              description="Esta ação irá retomar o lead para o funil de vendas, caso ele tenha sido finalizado e marcado uma conversão."
            />
          </div>
        )}

        {block?.data?.funnelAction === "editar_conversao_ganho" && (
          <div className="text-sm font-medium text-gray-700">
            Marcar Venda
          </div>
        )}

        {block?.data?.funnelAction === "editar_conversao_perda" && (
          <div className="text-sm font-medium text-gray-700">
            <div className="flex flex-col gap-2 mt-4">
              <RowInput
                label={'motivo da perda'}
                input={
                  <SelectZui
                    value={block?.data.lostReasonLead}
                    list={newReasons}
                    fullWidth
                    onChange={e => {
                      setSelectedReason(e);
                      let event = { name: "lostReasonLead", value: e }
                      changeBlock(event)
                    }}
                    itemSelect={(item) => (
                      <SelectItem key={item.value} value={item.value}>
                        {item.label}
                      </SelectItem>
                    )}
                  />
                }
              />
            </div>
          </div>
        )}

        {block?.data?.funnelAction === "editar_campanha" && (
          <div className="flex flex-col gap-1">
            <label htmlFor="campanha" className="text-sm font-medium">
              Campanha
            </label>
            <Select
              value={block?.data?.campanhaId}
              onValueChange={e => {
                let event = { name: "campanhaId", value: e }
                changeBlock(event)
              }}
            >
              <SelectTrigger className="w-full h-9 border-gray-200 hover:border-gray-300 focus:ring-2 focus:ring-green-500 focus:border-green-500 bg-white text-gray-900 text-sm">
                <SelectValue placeholder="Selecione a campanha" />
              </SelectTrigger>
              <SelectContent>
                {configCrm?.campanhas?.map((campanha) => (
                  <SelectItem key={campanha._id} value={campanha._id}>
                    {campanha.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        )}

        <AlertInfo
          title="Atenção"
          description="Se não houver nenhum lead vinculado, esta ação será ignorada."
        />
      </div>
    </div>
  );
};

export default CardChangeValue;
